import React, { useState, useEffect, useRef } from "react";
import { Table, Input, Spin } from "antd";
import axios from "axios";
import "./vleDetails.scss";
const BASE_URL = process.env.REACT_APP_CSC_API_BASE_URL;


const columns = [
  {
    title: "#",
    dataIndex: "index",
    key: "index",
    width: 70,
    align: "center",
  },
  {
    title: "VLE NAME",
    dataIndex: "fullname",
    key: "fullname",
  },
  {
    title: "CSC ID",
    dataIndex: "cscId",
  },
  {
    title: "Agent Id",
    dataIndex: "agentId",
    key: "agentId",
  },
  {
    title: "User Name",
    dataIndex: "username",
    key: "username",
  },
  {
    title: "EMAIL",
    dataIndex: "email",
    key: "email",
  },
  // Add more columns as per your API response structure
];

const VleDetails = () => {
  const [data, setData] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
  });
  const [search, setSearch] = useState("");
  const searchRef = useRef();

  // Fetch VLE data
  const fetchVleData = async (page = 1, pageSize = 10, searchText = "") => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${BASE_URL}api/csc/all-vle`,
        {
          params: {
            page,
            limit: pageSize,
            search: searchText,
          },
        }
      );
      const vleData = res.data.data || [];
      setData(
        vleData.map((item, idx) => ({
          ...item,
          index: (page - 1) * pageSize + idx + 1,
        }))
      );
      setTotalData(res.data || 0);
    } catch (err) {
      setData([]);
      setTotalData(0);
    } finally {
      setLoading(false);
    }
  };

  // console.log(totalData, "totalData");

  useEffect(() => {
    fetchVleData(tableParams.current, tableParams.pageSize, search);
    // eslint-disable-next-line
  }, [tableParams.current, tableParams.pageSize, search]);

  // Debounced search
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    if (searchRef.current) clearTimeout(searchRef.current);
    searchRef.current = setTimeout(() => {
      setSearch(value); // Only update search after debounce
      setTableParams((prev) => ({ ...prev, current: 1 }));
    }, 500);
  };

  const handleTableChange = (pagination) => {
    setTableParams({
      current: pagination.current,
      pageSize: pagination.pageSize,
    });
  };

  return (
    <div className="mainContain">
      <h1 className="transaction">All VLEs</h1>
      <div style={{ marginBottom: 16, maxWidth: 300 }}>
        <Input.Search
          placeholder="Search VLE"
          allowClear
          value={searchInput}
          onChange={handleSearch}
          style={{ width: "100%" }}
        />
      </div>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        rowKey="_id" // Use the unique _id from your API
        pagination={{
          total: totalData.total || 0,
          current: tableParams.current,
          pageSize: totalData.count || tableParams.pageSize,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ["10", "20", "50", "100", "200"],
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
        }}
        onChange={handleTableChange}
      />
      <Spin spinning={loading} tip="Loading..." style={{ display: loading ? 'flex' : 'none', justifyContent: 'center', marginTop: '20px' }}
        className="loading-spinner"
      />
    </div>
  );
};

export default VleDetails;